export default {
  account: {
    balance: 'beträgt Dein Kontostand',
    generalInfo: {
      label: 'Allgemeine Informationen',
      latestPurchase: 'Letzte Bestellung',
      latestPurchaseSubtitle: 'Deine letzte Bestellung bei konfetti.',
      accountBalance: 'Kontostand',
      accountBalanceSubtitle:
        'Benutze Dein Guthaben zum Kauf von weiteren Tickets. Es wird automatisch im Checkout angerechnet.',
      yourAccountBalance: 'Dein Kontostand',
    },
    orders: {
      label: 'Bestellungen',
      review: 'Bewertung abgeben',
      downloadPdf: 'PDF herunterladen',
      generateInvoice: 'Rechnung herunterladen',
      canceled: 'Gekanzelt',
      addInvoiceInformation: 'Rechnungsinformationen hinzufügen',
      invoiceEmailInfo:
        'Ihre Rechnung wird Ihnen per E-Mail zugesendet, bitte überprüfen Sie auch Ihren Spam-Ordner.',
      firstName: 'Vorname',
      lastName: 'Nachname',
      street: 'Straße',
      houseNumber: 'Hausnummer',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      companyName: 'Firmenname',
      vatId: 'USt-ID',
      po: 'PO Nummer',
      country: 'Land',
      germany: 'Deutschland',
      austria: 'Österreich',
      agreeToEmailInvoice:
        'Mit Klick auf "Abschicken" stimmen Sie zu, die Rechnung per E-Mail zu erhalten',
      send: 'Abschicken',
      prefilled: 'Vorbefüllt',
      invoiceRequestSuccess: 'Rechnungsanfrage erfolgreich übermittelt',
      type: {
        event: 'Veranstaltung',
        private: 'Privat',
        giftCard: 'Gutschein',
        kit: 'Bausatz',
        addon: 'Zusatz',
      },
    },
    userInfo: {
      label: 'Benutzerinformationen',
      currentPassword: 'Aktuelles Passwort',
      newPassword: 'Neues Passwort',
      passwordConfirmation: 'Passwortbestätigung',
    },
    referral: {
      label: 'Freunde werben',
      instructions: {
        title: 'Empfehle uns weiter und erhalte 20 €.',
        subtitle:
          'Geben Sie Ihren Empfehlungscode an Freunde weiter und Sie erhalten beide 20 € Rabatt auf Ihren nächsten Einkauf!',
        list: [
          'Teile Deinen persönlichen Code',
          'Deine Freunde erhalten 20 € Rabatt',
          'Du erhältst 20 € Guthaben nach dem Kauf',
        ],
      },
      codeInfo: {
        title: 'Hier ist Dein persönlicher Code',
        shareButton: 'Kopieren',
      },
      faq: {
        items: [
          {
            question: 'Wieviele Freunde kann ich werben, gibt es ein Limit?',
            answer:
              'Du kannst so viele Freunde einladen wie Du möchtest. Es besteht kein Limit.',
          },
          {
            question: 'Ist der Gutschein nur für Neukunden gültig?',
            answer: 'Ja, der Gutschein ist nur für Neukunden gültig.',
          },
          {
            question: 'Wann erhalte ich mein Guthaben?',
            answer:
              'Du erhältst Dein Guthaben nach dem erfolgreichen Kauf Deiner Freunde.',
          },
          {
            question: 'Gibt es ein Mindestbestellwert für meinen Freund?',
            answer: 'Ja, der Warenkorb muss mindestens 75 € betragen.',
          },
          {
            question: 'Wie kann ich mein Guthaben nutzen?',
            answer:
              'Du kannst Dein Guthaben für zukünftige Käufe bei konfetti nutzen und es wird automatisch im Checkout berücksichtigt.',
          },
        ],
      },
    },
    notifications: {
      label: 'Benachrichtigungen',
      newsletterSubscribe: 'Newsletter abonnieren',
    },
    changePassword: 'Passwortndern',
    form: {
      firstName: 'Vorname',
      lastName: 'Nachname',
      companyName: 'Firmenname (für Firmenkunden)',
      email: 'E-Mail',
      currentPassword: 'Aktuelles Passwort',
      password: 'Neues Passwort',
      passwordConfirmation: 'Passwortbestätigung',
      save: 'Speichern',
    },
    loginError:
      'Sie sind nicht berechtigt, diese Aktion durchzuführen. Laden Sie die Seite neu und versuchen Sie es erneut',
  },
}
